import isNumber from './is-number';
var isNegative = function (num) {
    return isNumber(num) && num < 0;
};
export default isNegative;
//# sourceMappingURL=is-negative.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-negative.js
// module id = 495
// module chunks = 3